import { render, staticRenderFns } from "./NewBaseTable.vue?vue&type=template&id=6e3a3069&"
import script from "./NewBaseTable.vue?vue&type=script&lang=js&"
export * from "./NewBaseTable.vue?vue&type=script&lang=js&"
import style0 from "./NewBaseTable.vue?vue&type=style&index=0&id=6e3a3069&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports